"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BibleComparisonDrawer = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const fa_1 = require("react-icons/fa");
const Button_1 = require("../Button");
const Image_1 = require("../Image");
const BibleComparisonModal_1 = require("./BibleComparisonModal");
const react_2 = require("@headlessui/react");
const useWindowSize_1 = __importDefault(require("../../hooks/useWindowSize"));
function BibleComparisonDrawer(_a) {
    var { className, bibles, buttonLinkClassName, closeBible, addItemToCart, setItemsToCompare, bibleModalOpen, setBibleModalOpen, getTranslation, locale, hasCartItems = false } = _a, props = __rest(_a, ["className", "bibles", "buttonLinkClassName", "closeBible", "addItemToCart", "setItemsToCompare", "bibleModalOpen", "setBibleModalOpen", "getTranslation", "locale", "hasCartItems"]);
    const drawerInactive = bibles.length === 0;
    const [drawerOpen, setDrawerOpen] = (0, react_1.useState)(true);
    const { isMobile, width } = (0, useWindowSize_1.default)();
    const mobileBreakpoint = width && width <= 960;
    const toggleDrawerTab = () => {
        setDrawerOpen(!drawerOpen);
    };
    const closeAllBibles = () => {
        sessionStorage.removeItem('itemsToCompare');
        setItemsToCompare([]);
    };
    (0, react_1.useEffect)(() => {
        if (bibles.length <= 1) {
            setBibleModalOpen(false);
        }
        else if (isMobile && bibles.length === 2) {
            setBibleModalOpen(true);
        }
    }, [bibles]);
    const handleCloseModal = () => {
        if (isMobile) {
            const recentBible = bibles[bibles.length - 1];
            closeBible(recentBible.itemNumber);
        }
        setBibleModalOpen(false);
    };
    return (react_1.default.createElement("div", Object.assign({ id: "bc-drawer", className: (0, classnames_1.default)(`fixed z-10 bottom-0 w-full left-0 py-2 px-4 transition-all transform shadow-md-all bg-white ${drawerInactive
            ? 'translate-y-full shadow-none'
            : drawerOpen
                ? 'translate-y-0 shadow-md-all'
                : 'translate-y-full shadow-md-all pb-3'}`, {
            'mb-16': mobileBreakpoint && hasCartItems,
        }, className) }, props),
        react_1.default.createElement("button", { className: `absolute right-16 top-0 -translate-y-full bg-white py-0.5 px-4 rounded-t-2xl z-108 group bg-white ${drawerInactive ? 'hidden' : 'block'}`, style: { boxShadow: '0 -3px 4px rgb(0 0 0 / 10%)' }, "aria-label": `${drawerOpen ? 'Close Compare Tab' : 'Open Compare Tab'}`, onClick: toggleDrawerTab },
            react_1.default.createElement("span", { className: `relative mr-2 text-gray text-sm ${drawerOpen ? 'hidden' : 'inline-block'}` },
                "Bible Comparison (",
                react_1.default.createElement("span", null, bibles.length),
                ")"),
            react_1.default.createElement("span", { className: `bg-none relative bg-blue inline-block rounded-full p-0.5 text-white text-xs top-1 group-hover:bg-blue-hover transition-colors ${!drawerOpen ? ' ' : ''} ` }, !drawerOpen ? (react_1.default.createElement(fa_1.FaChevronUp, { className: "" })) : (react_1.default.createElement(fa_1.FaChevronDown, { className: "text-white text-xs" })))),
        react_1.default.createElement("div", { className: "max-w-7xl mx-auto flex justify-center", style: { flexDirection: isMobile ? 'row-reverse' : 'row' } },
            react_1.default.createElement("div", { className: "self-center pr-4" },
                react_1.default.createElement("h2", { className: "text-lg lg:text-2xl mb-2 text-gray" }, isMobile ? '1 Bible Selected' : 'Compare Bibles'),
                react_1.default.createElement("p", { className: "text-gray-5 text-sm text-gray" }, isMobile
                    ? 'You can choose one additional bible to compare'
                    : 'You can compare up to 3 Bibles')),
            react_1.default.createElement("div", { className: "flex flex-row max-w-lg" }, bibles.map((bible) => {
                var _a;
                const findImageId = (_a = bible === null || bible === void 0 ? void 0 : bible.imageIds) === null || _a === void 0 ? void 0 : _a[0];
                const bibleImage = `/${findImageId !== null && findImageId !== void 0 ? findImageId : 'XXXXX'}`;
                return (react_1.default.createElement(react_2.Transition, { show: true, enter: "transition-all duration-200 ease-in", enterFrom: "transform opacity-0 scale-0", enterTo: "opacity-100 transform scale-100", leave: "transition-all duration-200 ease-out", leaveFrom: "transform w-24 scale-100 opacity-100", leaveTo: " transform w-0 scale-0 opacity-0", className: "transition-all relative w-24 max-w-full mt-4 mb-2 mx-3", key: bible.itemNumber },
                    react_1.default.createElement("h3", { className: "sr-only" }, bible.name),
                    react_1.default.createElement("div", { className: "relative h-0 pb-1/1 w-full" },
                        react_1.default.createElement("div", { className: "absolute bottom-0 left-0 right-0 top-0" },
                            react_1.default.createElement(Image_1.Image, { className: "max-w-full max-h-full ml-auto mr-auto flex self-end", src: bibleImage, alt: bible.name }))),
                    react_1.default.createElement("button", { className: "bg-none absolute -top-3 -right-2 text-gray-74", "aria-label": `Remove Item - ${bible.name}`, onClick: () => closeBible(bible.itemNumber) },
                        react_1.default.createElement(fa_1.FaRegTimesCircle, null))));
            })),
            react_1.default.createElement("div", { className: (0, classnames_1.default)('flex flex-col self-center justify-center text-center pl-6', {
                    hidden: isMobile,
                }) },
                react_1.default.createElement(Button_1.Button, { variant: "blue", size: "sm", className: (0, classnames_1.default)('cmp-biblecmp relative pr-6 mb-3'), disabled: bibles.length <= 1, onClick: () => setBibleModalOpen(true) },
                    "Compare Now",
                    react_1.default.createElement(fa_1.FaChevronRight, { className: "absolute right-1.5 text-md top-1/2 -translate-y-1/2" }),
                    ' '),
                react_1.default.createElement("button", { className: "text-gray-74 mt-1 -mb-2 text-xs flex-none", onClick: closeAllBibles },
                    react_1.default.createElement(fa_1.FaRegTimesCircle, { className: "inline-block relative -top-0.5 mr-1 text-sm" }),
                    ' ',
                    "Clear All")),
            react_1.default.createElement(BibleComparisonModal_1.BibleComparisonModal, { isOpen: bibleModalOpen, bibles: bibles, toggleModalIsOpen: setBibleModalOpen, closeBible: closeBible, closeAllBibles: () => {
                    closeAllBibles();
                    setBibleModalOpen(false);
                }, addItemToCart: addItemToCart, getTranslation: getTranslation, locale: locale, handleCloseModal: handleCloseModal }))));
}
exports.BibleComparisonDrawer = BibleComparisonDrawer;
